// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jwnA2","toggle":"styles_toggle__3kFPq","preview":"styles_preview__A2GDh"};